import { render, staticRenderFns } from "./tbd.vue?vue&type=template&id=58ef20b4&scoped=true&"
import script from "./tbd.vue?vue&type=script&lang=js&"
export * from "./tbd.vue?vue&type=script&lang=js&"
import style0 from "./tbd.vue?vue&type=style&index=0&id=58ef20b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ef20b4",
  null
  
)

export default component.exports